<template>
  <div id="vehicle_reg_create" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <span class="page-title" id="vehicleTypeHeader" v-if="$route.params.id > 0">View Warranty Registration Form</span>
          <span class="page-title" id="vehicleTypeHeader" v-else>Add Warranty Registration</span>
          <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackVehicleList">
            <i class="fp-back"> </i> Back
          </button>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content vehicle-registration-crud">
            <section class="internal-container border-top-table-fl">
              <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select"
                    id="VehicleTypeForm">
                <div class="form-row row-cols-md-4 row-cols-1">

                  <div class="col form-group">
                    <label class="control-label require" for="dealer_id">Dealer:</label>
                    <v-select v-if="loadAllDealers" v-model="dealer_id" name="dealer_id" label="text"
                              :filterable="false" :options="dealerArr"
                              @search="onSearchDealer" @change="onDealerChange($event)" placeholder="Select Dealer"
                              class='custom-ci-auto-search close-remove' :disabled="disableAllFields">
                      <template slot="no-options">
                        Search Dealer...
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.text }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.text }}
                        </div>
                      </template>
                    </v-select>
                    <v-select v-else v-model="dealer_id" name="dealer_id" label="text" :filterable="false"
                              :options="dealerArr"
                              @change="onDealerChange($event)" placeholder="Select Dealer"
                              class='custom-ci-auto-search close-remove' :disabled="disableAllFields">
                      <template slot="no-options">
                        Select Dealer...
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.text }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.text }}
                        </div>
                      </template>
                    </v-select>
                    <div class="field-error">{{ dealer_error_msg }}</div>
                  </div>

                  <div class="col form-group">
                    <label class="control-label" for="dealer_address">Dealer Address:</label>
                    <input type="text" class="form-control" v-model="dealer_address" name="dealer_address"
                           id="dealer_address" placeholder="Dealer Address" disabled>
                    <div class="field-error"></div>
                  </div>

                  <div class="col form-group">
                    <label class="control-label require" for="vehicle_id">Vin:</label>
                    <v-select v-model="vehicle_id" id="vehicle_id" name="vehicle_id" label="text" :filterable="false"
                              :options="vehicleArr" @search="onSearchAsset" @change="onAssetChange($event)"
                              placeholder="Select Unit"
                              class='custom-ci-auto-search close-remove'
                              :disabled="disableAllFields">
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.text }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.text }}
                        </div>
                      </template>
                      <span
                        v-if="dealer_id == undefined || dealer_id == '' ? true : false"
                        slot="no-options" @click="$refs.filterSelectCondition.open = false">
                          Select a Dealer first
                      </span>
                      <template v-else slot="no-options">
                        Search Unit...
                      </template>
                    </v-select>
                    <div class="field-error">{{ vehicle_error_msg }}</div>
                  </div>

                  <div class="col form-group">
                    <label class="control-label" for="year">Year:</label>
                    <input type="text" class="form-control" v-model="year" name="year" id="year" placeholder="Year"
                           disabled>
                    <div class="field-error"></div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label" for="make">Make:</label>
                    <input type="text" class="form-control" v-model="make" name="make" id="make"
                           placeholder="Enter Make" :disabled="disableAllFields">
                    <div class="field-error"></div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label" for="model">Model:</label>
                    <input type="text" class="form-control" v-model="model" name="model" id="model"
                           placeholder="Enter Model" :disabled="disableAllFields">
                    <div class="field-error"></div>
                  </div>

                  <div class="col form-group">
                    <label class="control-label require" for="odometer">Odometer:</label>
                    <input type="text" class="form-control" v-model="odometer" name="odometer" id="odometer"
                           placeholder="Enter Odometer" :disabled="disableAllFields">
                    <div class="field-error">{{ odometer_error_msg }}</div>
                  </div>

                  <div class="col form-group">
                    <label class="control-label require" for="date_of_sale">Date of Sale:</label>
                    <div class="input-group">
                      <date-picker placeholder="MM/DD/YYYY" id="date_of_sale" name="date_of_sale" v-model="date_of_sale"
                                   :config="dateOfSaleOptions"
                                   :disabled="disableAllFields"></date-picker>
                      <label for="date_of_sale" class="fp-calendar input-calender-icon"></label>
                    </div>
                    <div class="field-error">{{ date_of_sale_error_msg }}</div>
                  </div>

                  <div class="col form-group">
                    <label class="control-label require" for="consumer_id">Customer:</label>
                    <router-link v-if="canAddCustomer" class="pull-right color-blue link-text"
                                 v-bind:to="{ name: 'ConsumerCreate', params: { newCustomer: '', redirectFrom: 'VehicleRegistrationCreate'}, query: {dealerId: dealer_id.value} }"
                                 target="_blank"
                    >
                      <i class="fp-add" style="font-size:8px;font-weight:bold;"></i>
                      Add Customer
                    </router-link>
                    <v-select v-model="consumer_id" name="consumer_id" label="text" :filterable="false"
                              :options="consumerArr" @search="onSearchConsumer" @input="onConsumerChange"
                              placeholder="Select Customer" class='custom-ci-auto-search close-remove'
                              :disabled="disableAllFields">
                      <template slot="no-options">
                        Search Customer...
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.text }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.text }}
                        </div>
                      </template>
                    </v-select>
                    <div class="field-error">{{ consumer_error_msg }}</div>
                  </div>

                  <div class="col form-group">
                    <label class="control-label" for="consumer_address">Customer Address:</label>
                    <input type="text" class="form-control" v-model="consumer_address" name="consumer_address"
                           id="consumer_address" placeholder="Customer Address" disabled>
                    <div class="field-error"></div>
                  </div>

                  <div class="col form-group">
                    <label class="control-label" for="consumer_contact_name">Customer Contact Name:</label>
                    <input type="text" class="form-control" v-model="consumer_contact_name" name="consumer_contact_name"
                           id="consumer_contact_name" placeholder="Customer Contact Name" disabled>
                    <div class="field-error"></div>
                  </div>

                  <div class="col form-group">
                    <label class="control-label" for="consumer_phone">Customer Phone:</label>
                    <input type="text" class="form-control" v-model="consumer_phone" name="consumer_phone"
                           id="consumer_phone" placeholder="Customer Phone" disabled>
                    <div class="field-error"></div>
                  </div>

                  <div class="col form-group">
                    <label class="control-label" for="consumer_email">Customer Email:</label>
                    <input type="text" class="form-control" v-model="consumer_email" name="consumer_email"
                           id="consumer_email" placeholder="Customer Eamil" disabled>
                    <div class="field-error"></div>
                  </div>

                  <div class="col form-group">
                    <label class="control-label require" for="consumer_delivery_type">Customer Delivery Type</label>
                    <v-select v-model="consumer_delivery_type" name="consumer_delivery_type"
                              placeholder="Select Customer Delivery Type" label="text" :options="cdTypeArr"
                              id="consumer_delivery_type" :disabled="disableAllFields">
                    </v-select>
                    <div class="field-error">{{ cdtype_error_msg }}</div>
                  </div>

                  <div class="col form-group">
                    <label class="control-label"> </label>
                    <div class="custom-checkbox">
                      <label for="is_delay_start" class="checkbox-custom"> Delay Start
                        <input type="checkbox" v-model="is_delay_start" id="is_delay_start" name="is_delay_start"
                                :disabled="disableAllFields">
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>

                  <div class="col form-group">
                    <label :class="'control-label ' + dateInServiceRequireClass" for="date_in_service">Date in
                      Service:</label>
                    <div class="input-group">
                      <date-picker placeholder="MM/DD/YYYY" id="date_in_service" name="date_in_service"
                                   v-model="date_in_service" :config="dateInServiceOptions" :disabled="disableDateInService"></date-picker>
                      <label for="date_in_service" class="fp-calendar input-calender-icon"></label>
                    </div>
                    <div class="field-error">{{ date_in_service_error_msg }}</div>
                  </div>

                  <div class="col form-group" v-show="is_delay_start">
                    <label class="control-label require" for="delayStartReason">Reason for Delay:</label>
                    <textarea name="delayStartReason" class="form-control" id="delayStartReason" v-model="delayStartReason"
                              placeholder="Reason for Delay"></textarea>
                    <div class="field-error">{{ delay_start_reason_error_msg }}</div>
                  </div>

                </div>

                <!-- Basic Warranty -->
                <div class="col form-group">
                  <div v-if="basicRows.length > 0" class="table-responsive-sm">
                    <h5 class="color-darkblue font-semibold"> Coverage Details </h5>
                    <table class="table table-sm table-bordered font-1" style="width: 75%">
                      <thead>
                      <tr class="table-primary">
                        <th scope="col" class="w-25">Type</th>
                        <th scope="col" class="w-20">Years</th>
                        <th scope="col" class="w-20">Miles</th>
                        <th scope="col" class="w-20">End Date</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(read, index) in basicRows" :key="index">
                        <td>
                          <label class="control-label" for="">{{ read.warranty_type }}</label>
                        </td>
                        <td>
                          <label class="control-label" for="">{{ read.warranty_period }}</label>
                        </td>
                        <td>
                          <label class="control-label" for="">{{ read.warranty_miles.toLocaleString() }}</label>
                        </td>
                        <td>
                          <label class="control-label" for="">{{ read.end_date }}</label>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Extended Warranty -->
                <div v-if="showExtendedWarranty && rows && rows.length > 0" class="table-responsive-sm">
                  <h5 class="color-darkblue font-semibold"> Ext Warranty Purchased </h5>
                  <table class="table table-sm table-bordered font-1">
                    <thead>
                    <tr class="table-primary">
                      <th scope="col" class="w-25">Type</th>
                      <th scope="col" class="w-25">Purchase Date</th>
                      <th scope="col" class="w-25">Years</th>
                      <th scope="col" class="w-25">Miles</th>
                      <th scope="col" class="w-25">End Date</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(read, index) in rows" :key="index">

                      <td>
                        <label class="control-label" for="">{{ read.warranty_type }}</label>
                      </td>
                      <td>
                        <label class="control-label" for="">{{ read.str_date }}</label>
                      </td>
                      <td>
                        <label class="control-label" for="">{{ read.warranty_period }}</label>
                      </td>
                      <td>
                        <label class="control-label" for="">{{ read.warranty_miles.toLocaleString() }}</label>
                      </td>
                      <td>
                        <label class="control-label" for="">{{ read.end_date }}</label>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span
                    aria-hidden="true">&times;</span></button>
                  <strong id="errorMsg" class="field-error"></strong>
                </div>
                <div v-if="!disableAllFields" class="btn-groups mt-4">
                  <button type="submit" id="createVehicleTypeBtn" v-if="$route.params.id > 0" class="btn btn-primary"
                          v-on:click.prevent="CreateVehicleType">
                    Update
                  </button>
                  <button type="submit" id="createVehicleTypeBtn" v-else class="btn btn-primary"
                          v-on:click.prevent="CreateVehicleType">
                    Save
                  </button>
                  <button type="submit" id="createAndContinueVehicleTypeBtn" v-if="$route.params.id == undefined"
                          class="btn btn-tertiary" v-on:click.prevent="CreateVehicleType(flag = 'Save and Continue')">
                    Save and Continue
                  </button>
                  <button type="submit" id="cancelVehicleTypeBtn" class="btn btn-tertiary"
                          v-on:click.prevent="BackVehicleList">
                    Cancel
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>

  </div>
</template>
<script>
import Vue from "vue";
import LoadingContent from "@/components/LoadingContent.vue";
import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';
import vue2Dropzone from "vue2-dropzone";
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

Vue.component("loading-content", LoadingContent);

export default {
  name: "VehicleTypeCreate",
  components: {
    vueDropzone: vue2Dropzone,
    appFooter: () => import('@/components/Footer')
  },
  mixins: [commonMixins, contractMixins],
  metaInfo() {
    return {title: (this.$route.params.id > 0) ? "View Warranty Registration | " + process.env.COPYRIGHT_NAME : "Create Warranty Registration | " + process.env.COPYRIGHT_NAME}
  },
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    loading: false,
    vehicle_count: [],
    baseimg_path: null,
    img_path: "",
    fullPath: "",
    selectedFile: [],
    img_error_msg: "",
    basicRows: [],
    rows: [],
    sectionArr: [],
    readOnArr: [{text: 'Mandatory', value: 'mandatory'}, {text: 'Skip', value: 'skip'}],

    customerAddressArr: [],

    dealerArr: [],
    dealer_id: '',
    dealer_error_msg: '',

    dealer_address: '',

    is_ext_warranty: 0,

    vehicleArr: [],
    vehicle_id: '',
    vehicle_error_msg: '',

    year: '',
    make: '',
    model: '',

    odometer: '',
    odometer_error_msg: '',

    options: {
      format: 'MM/DD/YYYY',
      useCurrent: false,
    },
    date_of_sale: "",
    date_of_sale_error_msg: "",

    is_delay_start: 0,

    date_in_service: "",
    date_in_service_error_msg: "",

    dateInServiceRequireClass: 'require',

    consumerArr: [],
    consumer_id: '',
    consumer_error_msg: '',

    consumer_address: '',

    cdTypeArr: [{text: 'Retail', value: 'retail'},
      {text: 'Fleet', value: 'fleet'},
      {text: 'Dealer Rental', value: 'dealer rental'}],
    consumer_delivery_type: '',
    cdtype_error_msg: '',
    APIResponse: false,
    dropZonePreviewFiles: [],
    fileerror_msg: "",
    docArr: [],
    validateDocs: [],
    filesArr: [],
    vehicleRegistrationId: "",
    dropzoneOptions: {
      url: process.env.ROOT_API + "/vehicle-registration/store-document",
      method: 'POST',
      maxFilesize: 10.00, //MB
      maxFiles: 5,
      thumbnailWidth: 150, // px
      thumbnailHeight: 150,
      addRemoveLinks: true,
      acceptedFiles: ".jpg, .jpeg, .png, .pdf , .doc ,.docx",
      headers: {
        'Accept': 'application/json',
        "Access-Control-Allow-Origin": '*',
        "Authorization": "Bearer " + localStorage.getItem("tkn"),
        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
        "Cache-Control": "no-cache"
      },
      dictRemoveFileConfirmation: "Are you sure?You can\'t revert your action",
      destroyDropzone: false,
      dictDefaultMessage: "Drop files here to upload. Max allowed file size is 10MB.",
    },
    disableAllFields: false,
    isEdit: false,
    loadAllDealers: false,
    showExtendedWarranty: false,
    termsAndCondition: "<p class='text-left'>Customer Certification: By signing below, I certify that the above vehicle(s) will be used only for the above selected vocation/application. I specifically certify that the vehicle(s) will not be used for any military use and will not be diverted to any military product. I further certify that I intend to use the vehicle(s) within the United States and do not intend to re-sell the vehicle(s) to anyone outside of the United States.</p><p class='text-left'> I understand that all notices regarding the above vehicle(s), including warranty, recall, and field service campaign information, will be mailed to the above customer name and address. I acknowledge that I have received the applicable Owner’s Warranty Information book, and I accept the terms and conditions set forth therein, including the Limited Warranty Disclaimer and Limitation of Liability.</p><p class='text-left'> I certify that I have received the applicable Service Booklet(s), Operator’s Manual(s) and Driver’s Manual(s) for the above vehicle(s), or, I have received the website address where these documents may be obtained, if applicable. I have reviewed the terms of use for the vehicle telematics, if applicable, and hereby agree to those terms of use. If applicable, I have been instructed on correct fifth wheel operation. I acknowledge that the Federal Safety Standards and Emission stickers have been affixed to the driver’s side doorframe of the above vehicle(s). I acknowledge that I have been offered Extended Coverage warranty options (if applicable).</p>",
    dateOfSaleOptions: {
      format: 'MM/DD/YYYY',
      useCurrent: false
    },
    dateInServiceOptions: {
      format: 'MM/DD/YYYY',
      useCurrent: true,
      minDate: new Date(), // just a placeholder
      maxDate: new Date()
    },
    disableDateInService: false,
    delayStartReason: "",
    delay_start_reason_error_msg: "",
    consumer_contact_name: "",
    consumer_phone: "",
    consumer_email: "",
    canAddCustomer: false,
  }),
  watch: {
    //check permission change
    permissions: function (permissions) {
      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name == 'ev_add_vehicle_registration') {
            self.cantAccessPage = true;
          }
          if (permissions[i].name == 'ev_add_vehicle_registration') {
            self.cantAccessPage = true;
          }
          if (permissions[i].name == 'ev_load_all_dealer_dropdown') {
            self.loadAllDealers = true;
          }
          if (permissions[i].name == 'ev_add_customer') {
            self.canAddCustomer = true;
          }
        }
        if (!self.loadAllDealers) {
          let userObj = JSON.parse(localStorage.getItem("user_obj"));
          self.loadUserDealerMapper(userObj.id);
        }
      }
    },

    APIResponse: function (val) {
      var self = this;
      if (val) {
        if (self.customerAddressArr.customer_name != null && self.customerAddressArr.customer_code != null) {
          self.dealer_id = {
            text: self.customerAddressArr.customer_code + " | " + self.customerAddressArr.customer_name,
            value: self.customerAddressArr.customer_id
          };
          self.dealer_address = self.customerAddressArr.address_1;
          self.is_ext_warranty = self.customerAddressArr.customer_purchased_ext_warranty;
        }
      }
    },
    date_of_sale(dateOfSale){
      this.date_in_service = '';
      if(dateOfSale != "" && dateOfSale != null){
        this.disableDateInService = false;
        this.date_in_service_error_msg = "";
        this.dateInServiceOptions.minDate = dateOfSale;
      }else{
        this.disableDateInService = true;
        this.date_in_service_error_msg = "Need to select Date of Sale first!";
      }
      this.calculateDateInServiceMaxDate();

      if(this.date_of_sale && this.date_in_service && this.date_in_service < this.date_of_sale){
          this.date_in_service = '';
          this.date_in_service_error_msg = "Need to select Date of Sale first!";
        }
    },

    is_delay_start(value){
      if (value) {
        this.is_delay_start = 1;
        this.dateInServiceRequireClass = 'require';
        this.date_in_service_error_msg = 'Delay of Warranty Start Day is a Maximum of 30 days';
      } else {
        this.is_delay_start = 0;
        this.dateInServiceRequireClass = 'require';
        this.delayStartReason = "";
        this.delay_start_reason_error_msg = "";
        this.date_in_service_error_msg = "";
      }
      this.calculateDateInServiceMaxDate();
    }
  },
  created: function () {


  },
  mounted: function () {
    var self = this;
    self.loadFieldData(['customer_address']);
    self.getPermissions();
    /*
    var path = process.env.ROOT_API;
    var pathArr = path.split('/');
    console.log(pathArr);
    self.fullPath = pathArr[0]+'//'+pathArr[2] + "/";
    */
    var path = window.location.pathname;
    var segments = path.split("/");

    if (segments[3]) {
      self.isEdit = true;
      self.vehicleRegistrationId = segments[3];
      self.disableAllFields = true;
      self.loadVehicleRegistration();
    } else {

      // Get the current date
      const today = new Date();

      // Format the date to MM/DD/YYYY
      const formattedDate =
        (today.getMonth() + 1).toString().padStart(2, '0') + '/' +
        today.getDate().toString().padStart(2, '0') + '/' +
        today.getFullYear();

      // Assign the formatted date to the date_of_sale field
      this.date_of_sale = formattedDate;

      setTimeout(function () {
        if (self.customerAddressArr.customer_name != null && self.customerAddressArr.customer_name.customer_code != null) {
          self.dealer_id = {
            value: self.customerAddressArr.customer_code + " | " + self.customerAddressArr.customer_name,
            text: self.customerAddressArr.customer_id
          };
          self.dealer_address = self.customerAddressArr.customer_id;
        }
      }, 3000);


    }
    // self.getsectionArr();
  },
  methods: {
    calculateDateInServiceMaxDate(){
      // Handle the logic based on whether is_delay_start is true or false
      const dateOfSaleObj = new Date(this.date_of_sale); // Ensure this.date_of_sale is a Date object
      if (this.is_delay_start) {
        // Calculate 30 days from date_of_sale and set as maxDate
        this.dateInServiceOptions.maxDate = new Date(dateOfSaleObj.setDate(dateOfSaleObj.getDate() + 30));
      } else {
        // Set a very distant future date as maxDate to indicate "no limit"
        this.dateInServiceOptions.maxDate = new Date(9999, 11, 31); // December 31, 9999
      }
    },
    BackVehicleList() {
      var self = this;
      self.$router.push("/warrantyregistration/list");
    },

    onSearchDealer(search, loading) {
      var self = this;
      if (search.length > 2) {
        loading(true);
        self.searchField(loading, search, 'dealer', '');
      }
    },

    onDealerChange(value) {
      var self = this;
      if(value == '' || value == null){
        self.dealer_id = '';
      } else {
        if (self.dealer_id.address_line_1 != null) {
          self.dealer_address = self.dealer_id.address_line_1;
          self.is_ext_warranty = self.dealer_id.purchased_ext_warranty;
        }
      }
      if (self.consumer_id) {
        if (self.consumer_id.mapped_customer_parent_id !== self.dealer_id.parent_id) {
          self.consumer_id = null;
          self.consumerArr = [];
          self.consumer_address = '';
          self.consumer_contact_name = "";
          self.consumer_phone = "";
          self.consumer_email = "";
        }
      }
    },

    onSearchConsumer(search, loading) {
      var self = this;
      if (search.length > 2) {
        loading(true);
        self.searchField(loading, search, 'consumer', self.dealer_id.parent_id);
      }
    },

    onConsumerChange() {
      var self = this;
      if (self.consumer_id.address_line_1 != null) {
        self.consumer_address = self.consumer_id.address_line_1;
      }
      self.consumer_contact_name = self.consumer_id.contact_name;
      self.consumer_phone = self.consumer_id.phone_no;
      self.consumer_email = self.consumer_id.email;
    },

    onSearchAsset(search, loading) {
      var self = this;
      // use this in order to create new asset...
      self.searchedAsset = search;
      if (search.length > 2 && self.dealer_id.value != null) {
        loading(true);
        self.searchField(loading, search, 'vehicle_registration', self.dealer_id.parent_id);
      }
    },

    onAssetChange(value) {
      var self = this;
      if(value == '' || value == null){
        self.vehicle_id = '';
        self.vehicleArr = [];
      }else {
        if (self.vehicle_id.value != null) {
          self.year = self.vehicle_id.year;
          self.model = self.vehicle_id.model;
          self.make = self.vehicle_id.make;
          
          self.loadVehicleRegistrationCoverage();
        }
      }
    },

    saveId(evt, obj) {
      var self = this;
      if (obj.warranty_id) {
        for (var i = 0; i < self.rows.length; i++) {
          if (self.rows[i].warranty_id == obj.warranty_id) {
            //Set Ext Warranty Checkbox true if it is Checked
            if (evt.target.checked == true) {
              self.rows[i].ext_warranty = true;
            } else {
              self.rows[i].ext_warranty = false;
            }
          }
        }
      }
    },

    CreateVehicleType(flag) {
      var self = this;
      var error = false;
      var agree = true // setting as true since the pop-up is no longer required!

      self.dealer_error_msg = "";
      self.vehicle_error_msg = "";
      self.odometer_error_msg = "";
      self.consumer_error_msg = "";
      self.cdtype_error_msg = "";
      self.date_of_sale_error_msg = "";
      self.fileerror_msg = "";
      self.date_in_service_error_msg = '';
      self.delay_start_reason_error_msg = "";

      if (self.isEdit) {
        // validation for the file upload, has been commented out
        // error = self.validateBeforeSubmit();
        agree = true;
      }

      if (self.dealer_id == null || self.dealer_id == "") {
        self.dealer_error_msg = "Please select dealer.";
        error = true;
      }
      if (self.vehicle_id == null || self.vehicle_id == '' || self.vehicle_id.value == "") {
        self.vehicle_error_msg = "Please select unit.";
        error = true;
      }
      if (self.odometer == null || self.odometer == "") {
        self.odometer_error_msg = "Odometer required.";
        error = true;
      }
      if (self.date_of_sale == null || self.date_of_sale == '') {
        self.date_of_sale_error_msg = "Date of Sale required.";
        error = true;
      }
      if (self.is_delay_start == 0) { // date of service required only if Delay Start not marked
        if (self.date_in_service == null || self.date_in_service == '') {
          self.date_in_service_error_msg = "Date in Service required.";
          error = true;
        }
      }
      if (self.consumer_id == null || self.consumer_id == "") {
      	self.consumer_error_msg = "Please select customer.";
      	error = true;
      }else{
        if (self.consumer_id.value == null || self.consumer_id.value === ""){
          self.consumer_error_msg = "Please select customer.";
          error = true;
        }
      }
      if (self.consumer_delivery_type == null || self.consumer_delivery_type == "") {
        self.cdtype_error_msg = "Please select customer delivery type";
        error = true;
      }

      if(self.is_delay_start){
        if(self.delayStartReason == null || self.delayStartReason == ""){
          self.delay_start_reason_error_msg = "Delay Start Reason is Required!";
          error = true;
        }
      }

      if (!error) {

        self.loading = true;
        var path = window.location.pathname;
        var segments = path.split("/");
        if (segments[3]) {
          $("#createVehicleTypeBtn").val("Updating ...");
          $("#createVehicleTypeBtn").prop("disabled", true);
          $("#cancelVehicleTypeBtn").prop("disabled", true);
        } else {
          if (flag == "Save and Continue") {

            $("#createAndContinueVehicleTypeBtn").val("Saving ...");
            $("#createVehicleTypeBtn").prop("disabled", true);
            $("#createAndContinueVehicleTypeBtn").prop("disabled", true);
            $("#cancelVehicleTypeBtn").prop("disabled", true);

          } else {

            $("#createVehicleTypeBtn").val("Saving ...");
            $("#createVehicleTypeBtn").prop("disabled", true);
            $("#createAndContinueVehicleTypeBtn").prop("disabled", true);
            $("#cancelVehicleTypeBtn").prop("disabled", true);
          }

        }
        var formData = new FormData();
        //formData.append('myFile', self.selectedFile);

        formData.append('dealer_id', self.dealer_id.value);
        formData.append('vehicle_id', self.vehicle_id.value);

        formData.append('year', self.year);
        formData.append('make', self.make);
        formData.append('model', self.model);
        formData.append('odometer', self.odometer);
        formData.append('date_of_sale', self.date_of_sale);

        if (self.consumer_id != null && self.consumer_id.value) {
          formData.append('consumer_id', self.consumer_id.value);

        } else {
          formData.append('consumer_id', '');

        }
        formData.append('consumer_delivery_type', self.consumer_delivery_type.value);

        formData.append('is_delay_start', self.is_delay_start);
        formData.append('date_in_service', self.date_in_service);

        //Send Ext Warranty Data
        formData.append('ext_warranty_data', JSON.stringify(self.rows));

        formData.append('id', segments[3]);
        formData.append('file_path', self.docArr);
        formData.append('delayStartReason',self.delayStartReason);

        if(!agree){
          this.$swal({
            title: 'Do you Agree to the terms and conditions',
            html: self.termsAndCondition,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'I Agree',
            cancelButtonText: 'No',
            showCloseButton: false,
            showLoaderOnConfirm: true,
          }).then((result) => {
            if (result.value) {
              this.makeVehicleRegistrationCreateAPIRequest(formData,segments,flag);
            }else{
              self.loading = false;
              if (flag == "Save and Continue") {

                $("#createAndContinueVehicleTypeBtn").val("Save and Continue");
                $("#createVehicleTypeBtn").prop("disabled", false);
                $("#createAndContinueVehicleTypeBtn").prop("disabled", false);
                $("#cancelVehicleTypeBtn").prop("disabled", false);

              } else {

                $("#createVehicleTypeBtn").val("Save");
                $("#createVehicleTypeBtn").prop("disabled", false);
                $("#createAndContinueVehicleTypeBtn").prop("disabled", false);
                $("#cancelVehicleTypeBtn").prop("disabled", false);
              }
            }
          });
        }else{
          this.makeVehicleRegistrationCreateAPIRequest(formData,segments,flag)
        }
      } else {
        self.errorValidationFocus();
      }

    },

    removeElement: function (index) {
      var self = this;
      if (self.rows.length > 1) {
        self.rows.splice(index, 1);
      }
    },

    loadVehicleRegistration() {
      var path = window.location.pathname;
      var segments = path.split("/");
      var self = this;
      self.dropZonePreviewFiles = [];
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/vehicleregistration/" + segments[3],
        type: "GET",
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          "Access-Control-Allow-Headers":
            "Origin, Content-Type, Authorization,X-Requested-With",
          "Cache-Control": "no-cache"
        },
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status == "success") {
            self.year = data.content.year;
            self.make = data.content.make;
            self.model = data.content.model;
            self.odometer = data.content.odometer;
            self.date_of_sale = data.content.date_of_sale;
            if (self.isEdit) {
              if (data.filePath != "") {
                self.dropZonePreviewFiles = data.filePath;
                if (self.dropZonePreviewFiles.length > 0) {
                  self.loadFilesPreview();
                }
              }
            }
            self.date_in_service = data.content.date_in_service;
            if (data.content.vehicle_id != null) {
              var vehicleData = self.titleCase(data.content.vehicle_vin);
              if (data.content.vtCode != null) {
                vehicleData += " | " + self.titleCase(data.content.vtCode);
              }
              // if(data.content.vName != null){
              //     vehicleData += " | " + self.titleCase(data.content.vName);
              // }
              self.vehicle_id = {value: data.content.vehicle_id, text: vehicleData};
              //self.assetInfo = vehicleData;

            } else {
              self.vehicle_id = null;
            }

            if (data.content.dealer_id != null) {
              var dlrData = self.titleCase(data.content.dealer_code);
              if (data.content.dealer_name != null) {
                dlrData += " | " + self.titleCase(data.content.dealer_name);
              }
              self.dealer_id = {value: data.content.dealer_id, text: dlrData};
              self.dealer_address = data.content.dealer_address;
              self.is_ext_warranty = data.content.purchased_ext_warranty;
            } else {
              self.dealer_id = null;
              self.dealer_address = '';
              self.is_ext_warranty = 0;
            }

            if (data.content.consumer_id != null) {
              var dlrData = self.titleCase(data.content.consumer_code);
              if (data.content.consumer_name != null) {
                dlrData += " | " + self.titleCase(data.content.consumer_name);
              }
              self.consumer_id = {value: data.content.consumer_id, text: dlrData};
              self.consumer_address = data.content.consumer_address;
              self.consumer_contact_name = data.content.consumer_contact_name;
              self.consumer_phone = data.content.consumer_phone;
              self.consumer_email = data.content.consumer_email;

            } else {
              self.consumer_id = null;
              self.consumer_address = '';
              self.consumer_contact_name = '';
              self.consumer_phone = '';
              self.consumer_email = '';
            }

            self.consumer_delivery_type = {
              value: data.content.consumer_delivery_type,
              text: self.titleCase(data.content.consumer_delivery_type)
            };

            self.is_delay_start = data.content.is_delay_start;
            if (self.is_delay_start == 1) { // date of sale required only if Delay Start not marked
              self.dateInServiceRequireClass = '';
              self.date_in_service_error_msg = '';
            }

            self.loadVehicleRegistrationCoverage();

          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'vehicle-registration-load-by-id')
        }
      });
    },
    loadVehicleRegistrationCoverage() {
      var self = this;
      self.loading = true;

      var dealId = self.dealer_id;

      if (self.dealer_id && self.dealer_id.value) {
        dealId = self.dealer_id.value;
      }
      var formData = new FormData();
      formData.append('is_ext_warranty', self.is_ext_warranty);
      formData.append('dealer_id', dealId);

      //data: formData,

      $.ajax({
        url: process.env.ROOT_API + "/vehicleregistrationcoverage/" + self.vehicle_id.value,
        type: "POST",
        data: formData,
        headers: {
          "Accept": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          "Access-Control-Allow-Headers":
            "Origin, Content-Type, Authorization,X-Requested-With",
          "Cache-Control": "no-cache"
        },
        crossDomain: true,
        processData: false,
        contentType: false,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status == "success") {

            self.basicRows = data.content.basic;
            self.rows = data.content.extended;

            if (data.content.consumer != null && data.content.consumer != '') {
              self.consumer_id = {value: data.content.consumer.value, text: data.content.consumer.text};
              self.consumer_address = data.content.consumer.address;
            }

            //Set Ext Warranty Checkbox default false
            if (self.rows.length) {
              for (var i = 0; i < self.rows.length; i++) {
                self.rows[i].ext_warranty = false;
              }
            }


          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'vehicle-registration-load-by-id')
        }
      });
    },
    onFileChanged(event) {

      const file = event.target.files[0]
      var self = this;
      //only allow to upload image file
      if (file.type == "image/png" || file.type == "image/jpeg") {

        self.selectedFile = file;

        self.getBase64(self.selectedFile, function (base64Data) {
          self.baseimg_path = base64Data;
        });

      } else {

        $("#typeImage").val("");
        alert("Please select image file");
      }

    },
    getBase64: function (file, callback) {

      const reader = new FileReader();

      reader.addEventListener('load', () => callback(reader.result));

      reader.readAsDataURL(file);
    },
    //load files in drop zone
    loadFilesPreview: function () {
      var self = this;
      self.docArr = [];
      self.validateDocs = [];
      if (self.dropZonePreviewFiles.length > 0) {
        for (var i = 0; i < self.dropZonePreviewFiles.length; i++) {
          var url = self.dropZonePreviewFiles[i].url;
          // get file path from url
          self.docArr.push(self.getFilePathFromUrl(self.dropZonePreviewFiles[i].url));
          self.validateDocs.push({
            file_name: self.dropZonePreviewFiles[i].display_name,
            extension: self.dropZonePreviewFiles[i].extension
          });
        }
      }
    },
    getFilePathFromUrl(value) {

      var path = "";
      var src = value.split('/');
      var file_name = src[src.length - 1];
      var orgPath = src[src.length - 2];
      path = orgPath + "/" + file_name;
      return path;

    },
    afterComplete(file, response) {
      var self = this;
    },
    storeDocument(file, response) {
      var self = this;
      self.fileerror_msg = "";
      var uploadResponse = response;

      //push doc path in doc array
      self.docArr.push(uploadResponse.content);
      self.filesArr.push(file);
      if (file.type != undefined) {
        var extension = file.type.split("/");
        self.validateDocs.push({
          file_name: file.name,
          size: file.size,
          extension: extension[1]
        });
      }
    },
    removedSelectedFile(file, xhr, error) {
      var self = this;
      self.fileerror_msg = "";
      if (file.xhr != undefined) {
        var fileName = JSON.parse(file.xhr.response).content;

        var fileArr = fileName.split("/");

        self.removeFileFromServer(fileArr[1], "temp");

        for (var i = 0; i < self.docArr.length; i++) {
          if (self.docArr[i].includes(fileName)) {
            self.docArr.splice(i, 1);
            self.validateDocs.splice(i, 1);
            self.filesArr.splice(i, 1);
          }
        }
      }
    },

    removeFileFromServer(file, flag) {
      var self = this;
      var vehicleRegistration = self.$route.params.id;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/remove-vehicle-registration-file",
        type: "POST",
        data: {
          doc_path: file,
          id: vehicleRegistration,
          flag: flag
        },
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          "Access-Control-Allow-Headers":
            "Origin, Content-Type, Authorization,X-Requested-With",
          "Cache-Control": "no-cache"
        },
        dataType: "json",
        success: function (data) {
          self.loading = false;
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, true, 'vehicle-registration-doc-remove')
        }
      });
    },

    deleteVehicleRegistrationFile: function (key, file) {

      var self = this;

      if (confirm('Are you sure that you want to remove file? ')) {

        if (self.vehicleRegistrationId != '' && self.vehicleRegistrationId != undefined) {
          self.$parent.loading = true;

          $.ajax({
            url: process.env.ROOT_API + "/remove-vehicle-registration-file",
            type: "POST",
            crossDomain: true,
            dataType: "json",
            headers: {
              'Accept': "application/json",
              "Access-Control-Allow-Origin": "*",
              'Authorization': "Bearer " + localStorage.getItem("tkn"),
              "Access-Control-Allow-Headers":
                "Origin, Content-Type, Authorization,X-Requested-With",
              "Cache-Control": "no-cache"
            },
            data: {
              vehicleRegistrationId: self.vehicleRegistrationId,
              doc_path: file
            },
            success: function (data) {
              self.$parent.loading = false;
              if (data.status == "success") {
                self.filesArr.splice(key, 1);
                self.docArr.splice(key, 1);
                self.validateDocs.splice(key, 1);
                // self.loadClaimData(self.warranty_id);
                if (self.valuesFound) {
                  self.valuesFound = false;
                  self.matchingValuesError = [];
                }
                self.loadVehicleRegistration();
              }
            },
            error: function (jqXHR, exception) {
              self.$parent.loading = false;
              self.filesArr.splice(key, 1);
              self.docArr.splice(key, 1);
              self.validateDocs.splice(key, 1);
              self.generateStatusCodeMessage(jqXHR, true, 'vehicle-registration-doc-remove');
            }
          });

        } else {
          self.filesArr.splice(key, 1);
          self.$refs.files.value = '';
        }
      }
    },

    validateBeforeSubmit() {
      var self = this;
      var error = false;
      if (self.docArr.length > 0 && self.docArr.length < 2) {
        if (self.validateDocs.length > 0) {
          for (var i = 0; i < self.validateDocs.length; i++) {
            let fileObj = self.validateDocs[i];

            if (fileObj.extension != undefined) {
              if (fileObj.extension == "pdf" || fileObj.extension == "jpeg" || fileObj.extension == "png") {

              } else {
                self.fileerror_msg = "Only PDF/jepg/png Files Are Allowed (.pdf/.jpeg/.png).";
                error = true;
              }
            }

            if (fileObj.size != undefined) {
              if (fileObj.size > 10000000) {
                self.fileerror_msg = "File size should not be greater than 10 MB.";
                error = true;
              }
            }
          }
        }
      } else {
        self.fileerror_msg = "Cannot upload more than 1 files.";
        error = true;
      }
      return error;
    },

    makeVehicleRegistrationCreateAPIRequest(formData,segments,flag){
      var self = this;
      $.ajax({
        url: process.env.ROOT_API + "/vehicleregistration/create",
        type: "POST",
        data: formData,
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          "Access-Control-Allow-Headers":
            "Origin, Content-Type, Authorization,X-Requested-With",
          "Cache-Control": "no-cache"
        },
        crossDomain: true,
        processData: false,
        contentType: false,
        dataType: "json",
        success: function (data) {

          self.loading = false;
          if (segments[3]) {
            $("#createVehicleTypeBtn").val("Update");
            $("#createVehicleTypeBtn").prop("disabled", false);
            $("#cancelVehicleTypeBtn").prop("disabled", false);
          } else {
            if (flag == "Save and Continue") {

              $("#createAndContinueVehicleTypeBtn").val("Save and Continue");
              $("#createVehicleTypeBtn").prop("disabled", false);
              $("#createAndContinueVehicleTypeBtn").prop("disabled", false);
              $("#cancelVehicleTypeBtn").prop("disabled", false);
              self.baseimg_path = null;
              self.typeOrder = "";
              $("#typeImage").val("");

            } else {

              $("#createVehicleTypeBtn").val("Save");
              $("#createVehicleTypeBtn").prop("disabled", false);
              $("#createAndContinueVehicleTypeBtn").prop("disabled", false);
              $("#cancelVehicleTypeBtn").prop("disabled", false);

            }
          }
          if (data.status == "success") {

            if (flag == "Save and Continue") {
              $("#VehicleTypeForm").trigger("reset");

              self.dealer_id = '';
              self.dealer_address = '';
              self.vehicle_id = '';
              self.year = '';
              self.make = '';
              self.model = '';
              self.odometer = '';
              self.date_of_sale = '';
              self.consumer_id = '';
              self.consumerArr = [];
              self.consumer_address = '';
              self.consumer_delivery_type = '';
              self.is_delay_start = '';
              self.date_in_service = '';
              self.vehicleArr = [];
              self.basicRows = [];

              self.$swal('','Vehicle Registration Successfully Added.','info');
            } else {
              self.$router.push("/warrantyregistration/list");
            }

          } else if (data.code == 201) {
            self.$swal('', data.message, 'warning');
          } else {
            if (data.content.length > 0) {
              var err = "";
              for (var i = 0; i < data.content.length; i++) {
                err += data.content[i] + "<br>";
              }
              $("#errorMsg").html(err);
              $(".alert-warning").toggleClass("show");
              setTimeout(function () {
                $(".alert-warning").removeClass("show");
                $(".alert-warning").addClass("hide");
              }, 10000);
            }
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          if (segments[3]) {
            $("#createVehicleTypeBtn").val("Update");
            $("#createVehicleTypeBtn").prop("disabled", false);
            $("#cancelVehicleTypeBtn").prop("disabled", false);
          } else {
            if (flag == "Save and Continue") {

              // $("#VehicleTypeForm").trigger("reset");

              $("#createAndContinueVehicleTypeBtn").val("Save and Continue");
              $("#createVehicleTypeBtn").prop("disabled", false);
              $("#createAndContinueVehicleTypeBtn").prop("disabled", false);
              $("#cancelVehicleTypeBtn").prop("disabled", false);

            } else {

              $("#createVehicleTypeBtn").val("Save");
              $("#createVehicleTypeBtn").prop("disabled", false);
              $("#createAndContinueVehicleTypeBtn").prop("disabled", false);
              $("#cancelVehicleTypeBtn").prop("disabled", false);

            }
          }
          self.generateStatusCodeMessage(jqXHR, true, 'vehicle-registration-create')
        }
      });

    }

  }
};
</script>



// WEBPACK FOOTER //
// src/components/VehicleRegistrationCreate.vue